import './Documents.module.css';

import FileList from 'src/Components/ContentTemplate/Documents/FileList/FileList';

const Documents = () => {
  return (
    <div className="document-page">
      <FileList />
    </div>
  );
};

export default Documents;
